import type { GetActivityTypesQuery } from "@/graphql/graphql";

export type CallPlanModalActivityType = GetActivityTypesQuery["activityTypes"][number];

export const compareActivityTypes = (
  a: CallPlanModalActivityType,
  b: CallPlanModalActivityType
): number =>
  a.displayOrder - b.displayOrder || a.activityTypeLabel.localeCompare(b.activityTypeLabel);
